import { render, staticRenderFns } from "./CollectionComponent.vue?vue&type=template&id=110c6326&scoped=true&"
import script from "./CollectionComponent.vue?vue&type=script&lang=js&"
export * from "./CollectionComponent.vue?vue&type=script&lang=js&"
import style0 from "./CollectionComponent.vue?vue&type=style&index=0&id=110c6326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110c6326",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VImg,VRow})
